// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import myAccountFilterSectionStyles from "@steiner/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

dateRangeStyles.datePickersWrapper = {
    css: css`
        display: flex;
        align-items: flex-start;
        gap: 12px;
        &,
        & > div {
            flex: 1;
        }
        ${xScreen("lt", "xs")} {
            flex-direction: column;
            & > div {
                width: 100%;
            }
        }
    `,
};

dateRangeStyles.searchFieldWrapper = {
    wrapper: {
        css: css`
            width: 100%;
            flex: 0 1 calc(100% / 3 - 12px);
            min-width: 324px;
            display: flex;
            ${xScreen("lte", "md")} {
                flex: 0 1 100%;
            }
        `,
    },
};

dateRangeStyles.fromDate = {
    ...mergeWithCss(myAccountFilterSectionStyles.fromDate, {
        cssOverrides: {
            formField: css`
                display: flex;
            `,
        },
    }),
};

dateRangeStyles.toDate = {
    ...mergeWithCss(myAccountFilterSectionStyles.toDate, {
        cssOverrides: {
            formField: css`
                display: flex;
            `,

            datePicker: css`
                .react-calendar {
                    right: 0;
                    left: unset;
                }
            `,
        },
    }),
};
